import { create } from 'zustand';
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(isoWeek);

// Function to get start and end of current ISO week (Monday to Sunday)
const getWeekRange = (date) => {
  const startOfWeek = date.startOf("isoWeek");
  const endOfWeek = date.endOf("isoWeek");
  return {
    startDate: startOfWeek,
    endDate: endOfWeek,
  };
};

// Zustand store with default selectedWeek as the current week
const useStore = create((set) => ({
  selectedWeek: getWeekRange(dayjs()),
setSelectedWeek: (startDate, endDate) =>
  set({ selectedWeek: { startDate: dayjs(startDate), endDate: dayjs(endDate) } }),

}));

export default useStore;
